(() => {
  const storageKey = 'heirvaleCollectionColumns';

  function setColumns(columns) {
    const value = columns === '3' ? '3' : '2';
    document.body.classList.toggle('hv-icon-listing-three', value === '3');
    document.querySelectorAll('[data-hv-collection-columns]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.hvCollectionColumns === value));
    });
    try { window.localStorage.setItem(storageKey, value); } catch (_) {}
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hv-collection-columns]');
    if (button) setColumns(button.dataset.hvCollectionColumns);
  });

  document.addEventListener('shopify:section:load', () => {
    setColumns(document.body.classList.contains('hv-icon-listing-three') ? '3' : '2');
  });

  let saved = '2';
  try { saved = window.localStorage.getItem(storageKey) || '2'; } catch (_) {}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setColumns(saved), { once: true });
  } else {
    setColumns(saved);
  }
})();
